<template>
  <div class="app-block-loader" :style="{ minHeight }" role="status">
    <div class="app-block-loader__skeleton" aria-hidden="true">
      <span v-for="row in rows" :key="row" />
    </div>
    <div class="app-block-loader__spinner" aria-hidden="true"><app-spinner /></div>
    <span class="app-block-loader__label"><slot>Loading…</slot></span>
  </div>
</template>

<script>
import AppSpinner from './AppSpinner.vue'

export default {
  name: 'AppBlockLoader',
  components: { AppSpinner },
  props: {
    minHeight: { type: String, default: '140px' },
    rows: { type: Number, default: 3 }
  }
}
</script>

<style lang="scss" scoped>
.app-block-loader { position: relative; min-width: 0; overflow: hidden; background: #fff; }
.app-block-loader__skeleton { position: absolute; inset: 18px; display: flex; flex-direction: column; justify-content: space-evenly; gap: 12px; }
.app-block-loader__skeleton span { display: block; width: 82%; height: 12px; flex-shrink: 0; border-radius: 4px; background: #f2f3ef; }
.app-block-loader__skeleton span:nth-child(even) { width: 58%; }
.app-block-loader__spinner { position: absolute; top: 50%; left: 50%; width: 56px; height: 56px; transform: translate(-50%, -50%) scale(.5); border-radius: 50%; background: #fff; box-shadow: 0 0 0 14px #fff; }
.app-block-loader__label { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); white-space: nowrap; }
@media (prefers-reduced-motion: reduce) { .app-block-loader__spinner ::v-deep .spinner { animation: none; } }
</style>
